import React, { PureComponent } from "react";
import i18n from "i18next";

import { Icon } from "./../Common/Icon";
import { isBrowserSupported } from "../../helpers/browserHelpers";

export default class BrowserWarning extends PureComponent {
  state = {
    isVisible: true
  };

  isBrowserSupported = isBrowserSupported();

  handleVisibleChange = () => this.setState({ isVisible: false });

  render() {
    return (
      <div>
        {!this.isBrowserSupported &&
          this.state.isVisible && (
            <div className="browser-warning">
              <Icon onClick={this.handleVisibleChange} className="browser-warning__close" id="x" />
              <h4 className="browser-warning__title">{i18n.t("navbar.unsupported")}</h4>
              <p className="browser-warning__text">{i18n.t("navbar.unsupportedMessage")}</p>
            </div>
          )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/BrowserWarning.js